// src/contexts/VendorContext.js
import { createContext, useContext, useState } from 'react';

const VendorContext = createContext();

export const useVendor = () => useContext(VendorContext);

export const VendorProvider = ({ children }) => {
    const [vendor, setVendor] = useState(() => {
        const stored = localStorage.getItem('vendor');
        return stored ? JSON.parse(stored) : null;
    });

    const updateVendor = (vendorData) => {
        setVendor(vendorData);
        localStorage.setItem('vendor', JSON.stringify(vendorData));
    };

    return (
        <VendorContext.Provider value={{ vendor, updateVendor }}>
            {children}
        </VendorContext.Provider>
    );
};
